export const railStatuses = ['Active', 'In Place', 'Available', 'Unavailable'];
